import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../../app.component';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-typebreakdown-faultreport',
  templateUrl: './typebreakdown.component.html',
  styleUrls: ['./typebreakdown.component.sass']
})
export class TypebreakdownComponent implements OnInit {
  @Input() index;
  @Input() screenView;
  @Output() updateScreenView = new EventEmitter<any>();
  @Output() typeOfBreakdown = new EventEmitter<any>();
  @Input() subscriber;
  @Input() productType;
  public dateofReport;
  public openDays;
  public reportNumber;
  public ticketOpened;
  public ticketExists;
  public serviceEntry;
  constructor(private loadingScreenService: LoadingScreenService,private router: Router, public appComponent: AppComponent, private services: Service, private global: GlobalService) { }

  ngOnInit() {
    if (this.productType != "G") {
      this.loadStatus();
    }
  }

  continue1(index) {
    if (this.global.validateSession() === true) {
      var soloLinea_ = document.getElementById("solo_linea_" + index) as HTMLInputElement;
      var lineaDSL = document.getElementById("linea_dsl_" + index) as HTMLInputElement;
      if (soloLinea_.checked == true || lineaDSL.checked == true) {
        if (soloLinea_.checked == true) {
          this.typeOfBreakdown.emit("LINE");
        }
        else {
          this.typeOfBreakdown.emit("LINE+DSL");
        }
        this.screenView[index] = 2;
        this.updateScreenView.emit(this.screenView);
      }
      else {
        this.global.notif('Debe especificar el tipo de avería.');
      }
    }
  }

  loadStatus() {
    this.loadingScreenService.startLoading();
    this.services.CheckIfTicketExists(this.subscriber).subscribe(data => {
      this.loadingScreenService.stopLoading();
      this.serviceEntry = data.hasError;
      if (data.hasError == false) {
        this.ticketExists = data.errorDesc;
        this.ticketOpened = data.result[0].openTicket;
        this.dateofReport = data.result[0].commitmentDate;
        this.openDays = data.result[0].openDays;
        let day = new Date();
        this.openDays=this.global.subtractionDates(day,this.openDays);
        this.reportNumber = data.result[0].q_id;
      }
      else {
        this.ticketExists = data.errorDesc;
      }
    });
  }
  dateformat(data) {
    if (!!data) {
      let start = data.substring(6, 9) + '/';
      let middle = data.substring(4, 6) + '/';
      let end = data.substring(0, 4);
      return start + middle + end;
    }
  }
}